import { render, staticRenderFns } from "./CitiesSelect.vue?vue&type=template&id=3aa4227c&"
import script from "./CitiesSelect.vue?vue&type=script&lang=js&"
export * from "./CitiesSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports